<template>
  <div class="bucuresti">
    <h1>Bucureşti, Bukarest</h1>
    <article>
        Doriţi o prelungare? Faceţi un click pe o posa!
        Posele marcat cu "nn" nu sânt de la mine.<br/>
          Klicken Sie auf ein Foto, 
          um eine Vergrößerung zu erhalten<br>
          Mit (nn) markierte Fotos stammen nicht von mir.
      </article>
      
      <article class="fotos">
        <div class="foto">
          <img src="../assets/fotos/bucu_1kl.jpg" width="125" border="0" height="110" alt="Bucureşti, Bukarest: Palast von Ceaucescu (Foto M. Gnierim)" 
          @click="callImageClick('Bucureşti, Bukarest: Palast von Ceaucescu (Foto M. Gnierim)', 'bucu_1.jpg', $event)">
          <br>Bucureşti, Bukarest: Palast von Ceaucescu (Foto M. Gnierim)
        </div>
        <div class="foto">
          <img src="../assets/fotos/revo_1kl.jpg" width="125" border="0" height="110" alt="Bucureşti, Bukarest: Heldenfriedhof der Revolution 1989"
          @click="callImageClick('Bucureşti, Bukarest: Heldenfriedhof der Revolution 1989' , 'revo_1.jpg', $event)">
          <br>Bucureşti, Bukarest: Heldenfriedhof der Revolution 1989 (Foto M. Gnierim)
        </div>
        <div class="foto">
        <img src="../assets/fotos/buc_osama_kl.jpg" width="125" height="110" border="0" alt="Bucureşti, Bukarest: Osama bin Laden"
          @click="callImageClick('Bucureşti, Bukarest: Osama bin Laden' , 'buc_osama.jpg', $event)">
        <br>Bucureşti, Bukarest: Osama bin Laden
      </div>
      <div class="foto">
        <img src="../assets/fotos/bucu_2kl.jpg" width="125" height="110" border="0" alt="Bucureşti, Bukarest: Wintereinbruch 28.2.2006"
          @click="callImageClick('Bucureşti, Bukarest: Wintereinbruch 28.2.2006' , 'bucu_2.jpg', $event)">
        <br>Bucureşti, Bukarest: Wintereinbruch 28.2.2006
      </div>
      <div class="foto">
        <img src="../assets/fotos/bucu_3kl.jpg" width="125" border="0" height="110" alt="Bukarest / Bucuresti: Wintereinbruch 28.2.2006"
          @click="callImageClick('Bucureşti, Bukarest: Wintereinbruch 28.2.2006' , 'bucu_3.jpg', $event)">
        <br>Bucureşti, Bukarest: Wintereinbruch 28.2.2006
      </div>
      <div class="foto">
        <img src="../assets/fotos/bucu_4kl.jpg" width="125" height="110" border="0" alt="Bukarest / Bucuresti: Wintereinbruch 1.3.2006"
          @click="callImageClick('Bucureşti, Bukarest: Wintereinbruch 28.2.2006' , 'bucu_4.jpg', $event)">
        <br>Bukarest / Bucuresti: Wintereinbruch 1.3.2006
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'home',
  methods: {
  callImageClick(imgText, imgName, event) {
     this.$parent.handleImageClick(imgText, imgName, event);
    }
  }
}
</script>